<template>
  <transition name="fade">
    <div class="container-fluid" id="register">
      <script type="application/ld+json">
        {
          "@context": "http://schema.org",
          "@graph": [
            {
              "@type": "Article",
              "url": "https://www.teddi.co/register/",
              "headline": "Création de votre recherche ← Teddi",
              "description": "Inscrivez-vous, créez votre recherche et commencez à recevoir les alertes immobilières en temps réel.",
              "datePublished": "2020-06-14T17:47:50.000Z",
              "dateModified": "2020-06-15T09:20:51.000Z",
              "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://www.teddi.co/register/"
              },
              "publisher": {
                "@type": "Organization",
                "@id": "https://www.teddi.co/",
                "name": "Teddi",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://www.teddi.co/assets/socials/fb-profile.png",
                  "width": 1000,
                  "height": 1000
                }
              },
              "author": {
                "@type": "Person",
                "name": "Thomas"
              }
            }
          ]
        }
      </script>
      <b-row class="pt-md-4 vh-100">
        <b-col md="5" offset-md="2" class="px-md-4">
          <div class="d-flex align-items-center py-3">
            <b-img
              v-if="isFormPropertyView"
              class="icon-md mr-2"
              alt="waving-hands"
              :src="require('@/assets/icons/waving-hands.svg')"
            >
            </b-img>
            <!-- BACK -->
            <b-img
              v-if="isFormUserView"
              @click="
                isFormUserView = false;
                isFormPropertyView = true;
              "
              class="icon-md mr-2 cursor-pointer"
              alt="back-hands"
              :src="require('@/assets/icons/back-hands.svg')"
            >
            </b-img>

            <h1>Votre recherche</h1>
          </div>

          <b-form class="text-left">
            <div v-show="isFormPropertyView">
              <TransactionType />
              <transition name="fade">
                <PropertyType v-if="isTransactionTypeSet" class="mb-3" />
              </transition>
              <transition name="fade">
                <div
                  class="d-flex align-items-center"
                  v-if="isTransactionTypeSet && isPropertyTypeSet && !isPropertyTypeOpened"
                >
                  <h5 class="mb-0">
                    à
                  </h5>
                  <Location class="w-100" />
                </div>
              </transition>
              <transition name="fade">
                <div
                  class="d-flex align-items-center"
                  v-if="
                    isTransactionTypeSet && isPropertyTypeSet && isLocationSet && !isLocationOpened
                  "
                >
                  <h5 class="mb-0">
                    avec un budget maximum de
                  </h5>
                  <BudgetMax />
                </div>
              </transition>
              <transition name="fade">
                <div
                  class="d-flex align-items-center"
                  v-if="
                    isTransactionTypeSet && isPropertyTypeSet && isLocationSet && isBudgetMaxSet
                  "
                >
                  <h5 class="mb-0">
                    une surface minimum de
                  </h5>
                  <SurfaceMin />
                </div>
              </transition>
              <transition name="fade">
                <BedroomMin
                  v-if="
                    isTransactionTypeSet &&
                      isPropertyTypeSet &&
                      isLocationSet &&
                      isBudgetMaxSet &&
                      isSurfaceMinSet &&
                      isPropertyResidential
                  "
                />
              </transition>
            </div>
            <transition name="fade">
              <div v-if="isFormUserView">
                <h5 class="mb-2">
                  j'aimerais être notifié par email à
                </h5>
                <Email
                  v-if="
                    isTransactionTypeSet &&
                      isPropertyTypeSet &&
                      isLocationSet &&
                      isBudgetMaxSet &&
                      isSurfaceMinSet &&
                      isBedroomMinSet &&
                      !isBedroomMinOpened
                  "
                />
                <transition name="fade">
                  <div
                    class="mt-3"
                    v-if="
                      isTransactionTypeSet &&
                        isPropertyTypeSet &&
                        isLocationSet &&
                        isBudgetMaxSet &&
                        isSurfaceMinSet &&
                        isBedroomMinSet &&
                        isEmailSet &&
                        isEmailAvailable
                    "
                  >
                    <h5 class="mb-2">
                      un mot de passe pour accéder à votre compte<span class="ml-2"></span>
                    </h5>
                    <Password />
                  </div>
                </transition>
                <transition name="fade">
                  <div
                    class="mt-3"
                    v-if="
                      isTransactionTypeSet &&
                        isPropertyTypeSet &&
                        isLocationSet &&
                        isBudgetMaxSet &&
                        isSurfaceMinSet &&
                        isBedroomMinSet &&
                        isEmailSet &&
                        isEmailAvailable &&
                        isPasswordSet
                    "
                  >
                    <h5 class="mb-2">un code promo ?<span class="ml-2"></span></h5>
                    <Coupon />
                  </div>
                </transition>

                <div
                  class="mt-3"
                  v-if="
                    isTransactionTypeSet &&
                      isPropertyTypeSet &&
                      isLocationSet &&
                      isBudgetMaxSet &&
                      isSurfaceMinSet &&
                      isBedroomMinSet &&
                      isEmailSet &&
                      isPasswordSet &&
                      isFormUserView
                  "
                >
                  <p class="text-sm">
                    En sélectionnant le bouton ci-dessous, j'accepte les
                    <span
                      ><b-link to="/terms" target="_blank" rel="noopener"
                        >Conditions générales</b-link
                      ></span
                    >
                    et la
                    <span
                      ><b-link rel="noopener" to="/privacy" target="_blank"
                        >Politique de confidentialité</b-link
                      ></span
                    >
                    de Teddi.
                  </p>
                </div>
              </div>
            </transition>
          </b-form>
        </b-col>
        <b-col md="3" class="pb-5 pb-md-0 d-none d-md-block">
          <div class="d-flex align-items-center justify-content-center py-3 register-helper">
            <b-img class="icon-md mb-2" alt="teddi" :src="require('@/assets/logo/bear-face.png')">
            </b-img>
          </div>
          <RegisterHelper />
        </b-col>
      </b-row>
      <!-- NEXT -->
      <div
        @click="
          isFormUserView = true;
          isFormPropertyView = false;
          scrollToTop();
        "
        class="cursor-pointer d-flex justify-content-center fixed-bottom py-2 py-md-1 bg-blue"
        v-if="
          isTransactionTypeSet &&
            isPropertyTypeSet &&
            isLocationSet &&
            isBudgetMaxSet &&
            isSurfaceMinSet &&
            isBedroomMinSet &&
            !isBedroomMinOpened &&
            isFormPropertyView &&
            previsionCount < 100
        "
      >
        <IconNext v-if="isFormPropertyView" class="icon white slide-right" />
      </div>
      <!-- SUBMIT -->
      <div
        @click="register()"
        class="submit fixed-bottom py-2 py-md-1 bg-blue"
        v-if="
          isTransactionTypeSet &&
            isPropertyTypeSet &&
            isLocationSet &&
            isBudgetMaxSet &&
            isSurfaceMinSet &&
            isBedroomMinSet &&
            isEmailAvailable &&
            isEmailSet &&
            isPasswordSet &&
            isFormUserView
        "
      >
        <IconSubmit v-if="isFormUserView && isEmailSet" class="icon white" />
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import IconSubmit from "@/components/icons/IconSubmit.vue";
import IconNext from "@/components/icons/IconNext.vue";
import IconBack from "@/components/icons/IconBack.vue";

export default {
  components: {
    TransactionType: () =>
      import(/* webpackChunkName:"TransactionType"*/ "./../components/content/TransactionType.vue"),
    PropertyType: () =>
      import(/* webpackChunkName:"PropertyType"*/ "./../components/content/PropertyType.vue"),
    Location: () => import(/* webpackChunkName:"Location"*/ "./../components/content/Location.vue"),
    BudgetMax: () =>
      import(/* webpackChunkName:"BudgetMax"*/ "./../components/content/BudgetMax.vue"),
    BedroomMin: () =>
      import(/* webpackChunkName:"BedroomMin"*/ "./../components/content/BedroomMin.vue"),
    SurfaceMin: () =>
      import(/* webpackChunkName:"SurfaceMin"*/ "./../components/content/SurfaceMin.vue"),
    Email: () => import(/* webpackChunkName:"Email"*/ "./../components/content/Email.vue"),
    Coupon: () => import(/* webpackChunkName:"Coupon"*/ "./../components/content/Coupon.vue"),
    Password: () => import(/* webpackChunkName:"Password"*/ "./../components/content/Password.vue"),
    RegisterHelper: () =>
      import(/* webpackChunkName:"RegisterHelper"*/ "./../components/content/RegisterHelper.vue"),
    IconSubmit,
    IconNext,
    IconBack,
    Submit: () => import(/* webpackChunkName:"Submit"*/ "./../components/bottom/Submit.vue"),
  },
  metaInfo: {
    title: "Création de votre recherche",
    titleTemplate: "%s ← Teddi",
    meta: [
      { "http-equiv": "Content-Type", content: "text/html; charset=utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Inscrivez-vous, créez votre recherche et commencez à recevoir les alertes immobilières en temps réel.",
      },
      {
        property: "og:title",
        content: "Création de votre recherche ← Teddi",
      },
      { property: "og:site_name", content: "Teddi" },
      { property: "og:type", content: "website" },
      {
        property: "og:url",
        content: "https://www.teddi.co/register",
      },
      {
        property: "og:image",
        content: "https://www.teddi.co/assets/socials/fb-cover.jpg",
      },
      {
        property: "og:description",
        content:
          "Inscrivez-vous, créez votre recherche et commencez à recevoir les alertes immobilières en temps réel.",
      },
    ],
    link: [{ rel: "canonical", href: "https://www.teddi.co/register" }],
  },
  data() {
    return {
      isFormPropertyView: true,
      isFormUserView: false,
      isRecaptchaValid: false,
    };
  },
  computed: {
    ...mapState([
      "isPropertyTypeOpened",
      "isLocationOpened",
      "isBedroomMinOpened",
      "isPhoneValid",
      "previsionCount",
      "hasInputBeenChanged",
      "isEmailAvailable",
    ]),
    ...mapGetters([
      "isTransactionTypeSet",
      "isPropertyTypeSet",
      "isLocationSet",
      "isBudgetMaxSet",
      "isSurfaceMinSet",
      "isBedroomMinSet",
      "isEmailSet",
      "isPasswordSet",
      "isPropertyResidential",
    ]),
  },

  methods: {
    register() {
      this.$store.dispatch("registerUser");
    },
    recaptcha() {
      this.$refs.invisibleRecaptcha.execute();
    },
    onCaptchaExpired() {
      this.$refs.invisibleRecaptcha.reset();
    },
    async onCaptchaVerified(token) {
      this.$refs.invisibleRecaptcha.reset();
      this.$store.dispatch("registerUser");
    },
    setHasInputBeenChanged(value) {
      this.$store.commit("SET_HAS_INPUT_BEEN_CHANGED", value);
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
  mounted() {
    this.$store.dispatch("setStripe");
    if (
      this.$router.currentRoute.query.utm_campaign &&
      this.$router.currentRoute.query.utm_campaign == "takefive"
    )
      this.$store.commit("SET_SKIP_CHECKOUT", true);
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
@import "@/styles/transitions.scss";
h1 {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0;
}
form {
  div.d-flex {
    margin-bottom: 1rem;
  }
}
.register-helper {
  @include media-breakpoint-down(md) {
    margin-top: 15rem;
  }
}
</style>
